export const config = {
  'appURL': process.env.APP_URL,
  'eStoresURL': process.env.E_STORES_URL,
  'firebaseConfig': {
    apiKey: process.env.FIRE_BASE_CONFIG.API_KEY,
    authDomain: process.env.FIRE_BASE_CONFIG.AUTH_DOMAIN,
    databaseURL: process.env.FIRE_BASE_CONFIG.DATABASE_URL,
    projectId: process.env.FIRE_BASE_CONFIG.PROJECT_ID,
    storageBucket: process.env.FIRE_BASE_CONFIG.STORAGE_BUCKET,
    messagingSenderId: process.env.FIRE_BASE_CONFIG.MESSAGING_SENDERID
  }
}



// WEBPACK FOOTER //
// ./src/config.js